/* global PIXI Modernizr TweenMax TimelineMax Quad _ */
import React from 'react';
import PropTypes from 'prop-types';
import ReactDraw from 'react-draw/pixi';
import EventEmitter from 'wolfy87-eventemitter';
import Hammer from 'hammerjs';
// import debounce from 'lodash/debounce';
import Scenes from './scenes/index';
import Header from './partials/Header.jsx';
// import debug from 'debug';

import { sendPageView } from '../lib/analytics';
import Utils from '../lib/utils';
import Audio from '../lib/audio';
import { isMobile, isPhone, isTablet, isIOS, isIE } from '../lib/isMobile';
import StageActions from '../actions/StageActions';

import Chapters from '../data/chapters/index';

const mobile = isMobile();
const phone = isPhone();

function getOnfHeaderHeight() {
    return window.innerWidth >= 720 ? 60 : 36;
}

// console.log('initial size', window.devicePixelRatio, window.innerWidth, window.innerHeight);
// console.log('initial device', mobile ? 'mobile' : '', phone ? 'phone' : '');

var App = React.createClass({

    propTypes: {
        animationDuration: PropTypes.number,
        stage: PropTypes.object.isRequired,
        sceneName: PropTypes.string,
        language: PropTypes.string,
    },

    contextTypes: {
        store: PropTypes.object,
        router: PropTypes.object,
        language: PropTypes.string,
    },

    childContextTypes: {
        playing: PropTypes.bool,

        language: PropTypes.string,
        framesDone: PropTypes.object,
        guiContainer: PropTypes.object,

        renderer: PropTypes.object,
        events: PropTypes.object,
        debug: PropTypes.bool,
        messageBoxPlaying: PropTypes.bool,

        crisis: PropTypes.bool,
        crisisSound: PropTypes.bool,
        intensity: PropTypes.number,
        minIntensity: PropTypes.number,
        maxIntensity: PropTypes.number,
        instability: PropTypes.number,
        instabilityCrisisValue: PropTypes.number,
        intensitiesColors: PropTypes.object,

        interactionsCompleted: PropTypes.object,
        scenesCompleted: PropTypes.object,

        scale: PropTypes.number,
        originalWidth: PropTypes.number,
        originalHeight: PropTypes.number,
        cleanTint: PropTypes.number,
        dirtyTints: PropTypes.array,

        headerAppearance: PropTypes.oneOf(['full', 'transparent', 'statusOnly']),
        menuOpen: PropTypes.bool,
        soundBarOpen: PropTypes.bool,
        masterVolume: PropTypes.number,

        learnMoreOpened: PropTypes.bool,
        learnMoreContent: PropTypes.object,
        learnMoreKey: PropTypes.string,
        sceneKey: PropTypes.string,
    },

    getChildContext: function () {
        const props = this.props;
        const state = this.state;

        return {
            playing: this.props.stage.playing,

            language: this.props.stage.language,
            framesDone: this.props.stage.framesDone,
            guiContainer: state.guiContainer,

            renderer: state.renderer,
            events: state.events,
            debug: this.props.stage.debug,
            messageBoxPlaying: this.props.stage.messageBoxPlaying,

            crisis: props.crisis.crisis,
            crisisSound: props.crisis.crisisSound,
            intensity: props.crisis.intensity,
            minIntensity: props.crisis.minIntensity,
            maxIntensity: props.crisis.maxIntensity,
            instability: props.crisis.instability,
            instabilityCrisisValue: props.crisis.instabilityCrisisValue,
            intensitiesColors: props.crisis.intensitiesColors,

            interactionsCompleted: props.stage.interactionsCompleted,
            scenesCompleted: props.stage.scenesCompleted,

            scale: state.frameScale,
            originalWidth: props.stage.originalWidth,
            originalHeight: props.stage.originalHeight,
            cleanTint: props.stage.cleanTint,
            dirtyTints: props.stage.dirtyTints,

            headerAppearance: props.stage.headerAppearance,
            menuOpen: props.stage.menuOpen,
            soundBarOpen: props.stage.soundBarOpen,
            masterVolume: props.stage.masterVolume,

            learnMoreOpened: props.stage.learnMoreOpened,
            learnMoreContent: props.stage.learnMoreContent,
            learnMoreKey: props.stage.learnMoreKey,
            sceneKey: props.stage.sceneKey,
        };
    },

    getDefaultProps: function () {
        const headerHeight = getOnfHeaderHeight();

        return {
            sceneName: 'intro',
            animationDuration: 0.3,
            audioUrls: {
                crisisStart: '/audio/28nov/general-crise-descente-transition.mp3',
            },
            width: window.innerWidth,
            height: window.innerHeight - headerHeight,
            devicePixelRatio: Math.round(window.devicePixelRatio) || 1,
        };
    },

    audios: null,
    crisisTimeline: null,
    appElement: null,
    resizeCall: null,

    getInitialState: function () {
        const width = this.props.width;
        const height = this.props.height;
        const frameSize = this.getFrameSize(width, height);

        return {
            ready: false,
            mounted: false,

            mobile: isMobile(),
            width,
            height,

            frameScale: null,
            frameWidth: null,
            frameHeight: null,
            frameX: null,
            frameY: null,
            ...frameSize,
            devicePixelRatio: this.props.devicePixelRatio,

            stage: null,
            scenesContainer: null,
            storiesContainer: null,
            guiContainer: null,
            crisisFrame: null,
            renderer: null,
            rendererType: 'webgl',

            mouseDown: false,
            mouseClientX: null,
            mouseClientY: null,

            hasResized: false,

            events: new EventEmitter(),

            storiesOriginalWidth: null,
            storiesOriginalHeight: null,

            scaleX: 1,
            scaleY: 1,
            onReadyCalled: false,
        };
    },

    render: function () {
        const canvas = this.renderCanvas();
        const scenes = this.renderScenes();
        const header = this.renderHeader();
        const landscape = this.renderHideMobileLandscape();

        const userEvents = {};
        if (!Modernizr.touchevents) {
            userEvents.onWheel = this.onWheel;
        }

        const style = {
            width: this.state.width,
            height: this.state.height,
        };

        return (
            <div className="app-content" {...userEvents} style={style} ref={(el) => { this.appElement = el; }}>
                { canvas }
                { header }
                { scenes }
                { landscape }
            </div>
        );
    },

    renderScenes: function () {
        const props = this.props;
        const state = this.state;

        const headerHeight = getOnfHeaderHeight();
        const SceneComponent = Scenes[props.sceneName.replace('-', '')];

        const SceneProps = {
            rendererType: state.rendererType,
            buildOnLoad: true,
            ref: 'currentScene',
            mobile: state.mobile,
            // width: state.width,
            // height: state.height,

            width: window.innerWidth,
            height: window.innerHeight - headerHeight,

            pageKey: props.stage.pageKey,
            sceneKey: props.stage.sceneKey,
            frameX: state.frameX,
            frameY: state.frameY,
            frameWidth: state.frameWidth,
            frameHeight: state.frameHeight,
            frameScale: state.frameScale,
            headerHeight: state.headerHeight,

            device: state.device,
            mouseDown: state.mouseDown,
            learnMoreOpened: props.stage.learnMoreOpened,
            learnMoreContent: props.stage.learnMoreContent,
            learnMoreKey: props.stage.learnMoreKey,

            devicePixelRatio: state.devicePixelRatio,

            skipIntro: props.stage.skipIntro,

            scenesContainer: state.scenesContainer,
            storiesContainer: state.storiesContainer,

            onMessageWillShow: this.onMessageWillShow,
            onSceneChange: this.onSceneChange,
            onToggleMenu: this.onToggleMenu,
            onWindowResize: this.onWindowResize,
            onWindowFocus: this.onWindowFocus,
            setPreviousVolume: this.setPreviousVolume,

            onSceneMount: this.onSceneMount,
            onSceneUnmount: this.onSceneUnmount,
        };

        const blockclass = props.sceneName !== 'credits' ? 'scenes-container' : 'full-page-container';

        return (
            <div className={blockclass}>
                <SceneComponent {...SceneProps} />
            </div>
        );
    },

    renderCanvas: function() {
        const {
            width,
            height,
            devicePixelRatio,
            mounted,
        } = this.state;

        const size = {
            width,
            height,
        };

        return (
            <ReactDraw
                {...size}
                tick={false}
                onReady={this.onReady}
                rendererOptions={{
                    roundPixels: false,
                    transparent: false,
                    antialias: false, // bad for perf
                    autoResize: false,
                    // resolution: 1,
                    // legacy: mobile,
                    resolution: devicePixelRatio,
                }}
            />
        );
    },

    renderHeader: function() {
        const { frameScale, width } = this.state;

        if (!frameScale) {
            return null;
        }

        return (
            <Header
                scale={frameScale}
                frameWidth={width}
                onToggleMenu={this.onToggleMenu}
                onTogglePause={this.onTogglePause}
                onToggleSoundBar={this.onToggleSoundBar}
                onSceneChange={this.onSceneChange}
            />
        );
    },

    renderHideMobileLandscape: function() {
        const {
            width,
            height,
        } = this.state;

        const mobileState = this.state.mobile;

        const {
            language,
        } = this.props;

        if (!mobileState) return;
        if (height > width) return;

        const realHeight = isIOS() ? height + 44 : height;

        let top = this.props.stage.menuOpen === true ? -height : 0;
        top = this.props.stage.learnMoreOpened === true ? height : top;

        const style = {
            width,
            height: realHeight,
            top,
        };

        return (
            <div className={`mobile-landscape ${language}`} style={style}>
                <div className="message" />
            </div>
        );
    },

    /*
     * Life cycle
     */

    componentWillMount() {
        this.context.store.dispatch(
            new StageActions.setLanguage(this.props.language),
        );
    },

    componentDidMount: function() {
        var scene = this.refs.currentScene;
        scene.play();

        this.addWindowEvents();

        this.audios = {};
        _.forOwn(this.props.audioUrls, _.bind(function(value, key){
            this.audios[key] = new Audio(value);
        }, this));

        // TweenMax.ticker.fps(45);
        TweenMax.ticker.addEventListener('tick', this.onTick);

        this.context.store.dispatch(
            StageActions.setFrameDone(this.props.stage.sceneKey, 0),
        );

        this.onWindowFocus();

        // console.log('MOUNT');
        this.setState({
            mounted: true,
        });
    },

    componentWillReceiveProps(nextProps, nextContext) {
        if (nextProps.stage.sceneKey !== this.props.stage.sceneKey) {
            this.context.store.dispatch(
                StageActions.setFrameDone(nextProps.stage.sceneKey, 0),
            );
        }
    },

    componentDidUpdate: function(prevProps, prevState) {
        const sizeChanged = prevState.width !== this.state.width || prevState.height !== this.state.height;

        const crisisChanged = prevProps.crisis.crisis !== this.props.crisis.crisis;
        const volumeChanged = this.props.stage.masterVolume !== prevProps.stage.masterVolume;
        const playingChanged = this.props.stage.playing !== prevProps.stage.playing;
        const learnMoreChanged = this.props.stage.learnMoreOpened !== prevProps.stage.learnMoreOpened;
        const menuOpenChanged = this.props.stage.menuOpenChanged !== prevProps.stage.menuOpenChanged;

        const readyActivated = this.state.ready !== prevState.ready &&
            this.state.ready === true && prevState.ready === false;

        const readyDeactivated = this.state.ready !== prevState.ready &&
            this.state.ready === false && prevState.ready === true;

        if (readyActivated) {
            // console.log('resize activated');
            window.addEventListener('resize', this.onWindowResize);
            window.addEventListener('focus', this.onWindowFocus);
            window.addEventListener('blur', this.onWindowBlur);
            this.onWindowResizeWithTimeout();
        }

        if (readyDeactivated) {
            // console.log('resize deactivated');
            window.removeEventListener('resize', this.onWindowResize);
            window.removeEventListener('focus', this.onWindowFocus);
            window.removeEventListener('blur', this.onWindowBlur);
        }

        if (crisisChanged) {
            if (this.props.crisis.crisis === true) {
                this.startCrisis();
            } else {
                this.stopCrisis();
            }

            // console.log('crisis changed', this.props.crisis);
        }

        if (playingChanged && !this.props.stage.menuOpen) {
            if (this.props.stage.playing) {
                if (this.state.previousVolume) {
                    this.context.store.dispatch(StageActions.setMasterVolume(this.state.previousVolume));
                }
            } else {
                this.setState({
                    previousVolume: this.props.stage.masterVolume,
                }, () => {
                    this.context.store.dispatch(StageActions.setMasterVolume(0));
                });
            }
        }

        if (menuOpenChanged && this.props.stage.menuOpen) {
            this.setState({
                previousVolume: this.props.stage.masterVolume,
            });
        }

        if (learnMoreChanged) {
            if (!this.props.stage.learnMoreOpened) {
                this.context.store.dispatch(StageActions.setMasterVolume(this.state.previousVolume));
            } else {
                this.setState({
                    previousVolume: this.props.stage.masterVolume,
                }, () => {
                    this.context.store.dispatch(StageActions.setMasterVolume(0));
                });
            }
        }
    },

    componentWillUnmount: function() {
        this.removeWindowEvents();

        this.audios = null;
        this.crisisTimeline = null;

        TweenMax.ticker.removeEventListener('tick', this.onTick);

        window.removeEventListener('resize', this.onWindowResize);
        // window.removeEventListener('deviceorientation', this.onWindowResizeWithTimeout);
        // window.removeEventListener('orientationchange', this.onWindowResizeWithTimeout);
        window.removeEventListener('focus', this.onWindowFocus);
        window.removeEventListener('blur', this.onWindowBlur);
    },

    /*
     * Methods
     */

    onWindowResize: function() {
        const headerHeight = getOnfHeaderHeight();
        const width = window.innerWidth;
        const height = window.innerHeight - headerHeight;
        const frameSize = this.getFrameSize(width, height);

        // console.log('RESIZE', 'W', 'H', width, height, frameSize);

        this.setState({
            width,
            height,
            devicePixelRatio: window.devicePixelRatio || 1,
            ...frameSize,
            hasResized: !this.state.hasResized,
        }, () => {
            this.resize();
            this.onWindowFocus();
        });
    },

    onWindowResizeWithTimeout: function () {
        setTimeout(() => {
            this.onWindowResize();
        }, 400);
    },

    onWindowFocus: function(e) {
        // console.log('focus');
        if (!this.props.stage.menuOpen && !this.props.stage.learnMoreOpened) {
            this.context.store.dispatch(StageActions.setPlaying(true));
        }
        this.resize();
    },

    onWindowBlur: function(e) {
        // console.log('blur');
        this.context.store.dispatch(StageActions.setPlaying(false));
    },

    startCrisis: function() {
        this.audios.crisisStart.play({
            time: 0,
        });

        if (this.crisisTimeline) {
            this.crisisTimeline.kill();
        }
        const timeline = new TimelineMax();
        this.crisisTimeline = timeline;

        timeline.to(this.state.crisisFrame, 20, {
            alpha: 0.6,
            ease: Quad.easeInOut,
        }, 2);

        // black and white characters
        var blackAndWhiteFilter = new PIXI.filters.ColorMatrixFilter();
        blackAndWhiteFilter.desaturate();
        var characters = this.getSpritesMatchingUserData('character', true);

        function updateFilter(sprite) {
            if (sprite.filters === null)
            {
                sprite.filters = [blackAndWhiteFilter];
            } else {
                sprite.filters = null;
            }
        }

        function removeFilter(sprite) {
            sprite.filters = null;
        }

        _.each(characters, function(character){
            character.filters = [blackAndWhiteFilter];

            var characterTimeline = new TimelineMax();
            characterTimeline.to({}, 1, {
                repeat: 5,
                onRepeat: updateFilter,
                onRepeatParams: [character],
                onComplete: removeFilter,
                onCompleteParams: [character]
            });

            timeline.add(characterTimeline, 0);
        });
    },

    stopCrisis: function()
    {
        if (this.crisisTimeline) {
            this.crisisTimeline.kill();
        }
        _.each(this.getSpritesMatchingUserData('character', true), function(character){
            character.filters = null;
        });

        var timeline = new TimelineMax();
        this.crisisTimeline = timeline;
        timeline.to(this.state.crisisFrame, 8, {
            alpha: 0,
            ease: Quad.easeInOut,
        });
    },

    updateCrisis: function(crisis)
    {
        // var frameChannelVolume = 0.2;
        // TweenMax.to({volume: crisis ? 1 : frameChannelVolume}, 1, {
        //     volume: crisis ? frameChannelVolume : 1,
        //     onUpdate: function() {
        //         Audio.setChannelVolume('frame', this.target.volume);
        //     }
        // });
    },

    resize: function(instant)
    {
        const { storiesContainer, storiesFrame, frameX, frameY, frameWidth, frameHeight } = this.state;

        if (storiesContainer !== null && storiesFrame !== null) {
            storiesFrame.width = frameWidth;
            storiesFrame.height = frameHeight;

            storiesContainer.x = frameX;
            storiesContainer.y = frameY;

            storiesContainer.scale.x = storiesFrame.scale.x;
            storiesContainer.scale.y = storiesFrame.scale.y;
        }
    },

    addWindowEvents: function () {
        if (!Modernizr.touchevents) {
            window.addEventListener('mousedown', this.onMouseDown);
            window.addEventListener('mousemove', this.onMouseMove);
            window.addEventListener('mouseup', this.onMouseUp);
        } else {
            this.mc = new Hammer.Manager(this.appElement);
            const Swipe = new Hammer.Swipe({ direction: Hammer.DIRECTION_HORIZONTAL, threshold: 5, velocity: 0.2 });
            const Pan = new Hammer.Pan({ direction: Hammer.DIRECTION_VERTICAL });

            this.mc.add(Pan);
            this.mc.add(Swipe);

            this.mc.get('swipe').recognizeWith(Pan);

            this.mc.on('swipeleft', (e) => {
                if (!this.props.stage.playing) return;
                // console.log('swipeleft', e);
                this.state.events.emit('swipeleft', {
                    event: e,
                    type: 'swipeleft',
                });
            });

            this.mc.on('swiperight', (e) => {
                if (!this.props.stage.playing) return;
                // console.log('swiperight', e);
                this.state.events.emit('swiperight', {
                    event: e,
                    type: 'swiperight',
                });
            });

            this.mc.on('pan', (e) => {
                if (!this.props.stage.playing) return;
                this.state.events.emit('pan', {
                    event: e,
                    type: 'pan',
                });
            });

            this.mc.on('panstart', (e) => {
                if (!this.props.stage.playing) return;
                this.state.events.emit('panstart', {
                    event: e,
                    type: 'panstart',
                });
            });

            this.mc.on('panend', (e) => {
                if (!this.props.stage.playing) return;
                this.state.events.emit('panend', {
                    event: e,
                    type: 'panend',
                });
            });
        }
    },

    removeWindowEvents: function () {
        if (!Modernizr.touchevents) {
            window.removeEventListener('mousedown', this.onMouseDown);
            window.removeEventListener('mousemove', this.onMouseMove);
            window.removeEventListener('mouseup', this.onMouseUp);
        } else {
            this.mc.off('swipeleft');
            this.mc.off('swiperight');
            this.mc.off('pan');
            this.mc.remove('swipe');
            this.mc.remove('pan');
            this.mc.destroy();
        }
    },

    getFrameSize: function(width, height) {
        const hasOffset = isPhone() && (height > width);
        const maxHeight = hasOffset ? null : height;
        const prelimFrameSize = Utils.getSizeWithinMax(_.get(this.props.stage, 'originalWidth'), _.get(this.props.stage, 'originalHeight'), width, maxHeight, { multipleOfTwo: true });

        const frameSize = prelimFrameSize.ratio > 0.60 ?
                Utils.getSizeWithinMax(_.get(this.props.stage, 'originalWidth'), _.get(this.props.stage, 'originalHeight'), width, height, { multipleOfTwo: true })
                : prelimFrameSize;

        // console.log('ratio', frameSize.ratio, parseFloat((Math.round(frameSize.ratio * 5000) / 5000).toFixed(4)));
        // Not intuitive but divide 100 by 50 and you only get multiples of 2
        const scale = parseFloat((Math.round(frameSize.ratio * 5000) / 5000).toFixed(4));

        const frameWidth = frameSize.width;
        const frameHeight = frameSize.height;
        let device = isMobile() ? 'mobile' : 'desktop';

        if (isTablet()) {
            device = 'tablet';
        } else if (isPhone()) {
            device = 'phone';
        }

        return {
            mobile: isMobile(),
            device,
            frameWidth,
            frameHeight,
            frameX: (width - frameWidth) / 2,
            frameY: 0, // ((height - frameHeight) / 2),
            frameScale: scale,
            cropped: prelimFrameSize.ratio <= 0.6,
            headerHeight: getOnfHeaderHeight(),
        };
    },

    getSpritesMatchingUserData: function(key, value) {
        const sprites = [];
        function checkSprite(sprite) {
            if (_.get(sprite, `userData.${key}`) === value) {
                sprites.push(sprite);
            }

            if (sprite.children && sprite.children.length) {
                _.each(sprite.children, checkSprite);
            }
        }
        checkSprite(this.state.storiesContainer);
        return sprites;
    },

    /*
     * Events handlers
     */

    onReady: function (renderer, stage) {
        if (this.state.onReadyCalled === true) {
            this.onWindowResize();
            return;
        }

        // console.log('app', stage, this.state);

        const rendererType = renderer.type === PIXI.RENDERER_TYPE.WEBGL ? 'webgl' : 'canvas';

        const headerHeight = getOnfHeaderHeight();
        const width = window.innerWidth;
        const height = window.innerHeight - headerHeight;

        const frameSize = this.getFrameSize(width, height);

        // console.log('nice', stage, this.state, frameSize, width, height);

        const scenesContainer = new PIXI.Container();
        const storiesContainer = new PIXI.Container();

        const guiContainer = new PIXI.Container();
        const appContainer = document.getElementById('app');

        const globalContainer = new PIXI.Container();
        globalContainer.interactiveChildren = false; // removes all interaction

        guiContainer.x = -appContainer.offsetLeft;
        guiContainer.y = -appContainer.offsetTop;

        scenesContainer.alpha = this.props.stage.zoom !== this.props.stage.maxZoom ? 1 : 0;

        const storiesFrame = new PIXI.Graphics();
        storiesFrame.beginFill(0, 0);
        storiesFrame.drawRect(0, 0, frameSize.frameWidth, frameSize.frameHeight);
        storiesFrame.endFill();
        storiesFrame.scale.x = 1;
        storiesFrame.scale.y = 1;

        const crisisFrame = new PIXI.Graphics();
        crisisFrame.beginFill(0, 0.9);
        crisisFrame.drawRect(0, 0, renderer.width, renderer.height);
        crisisFrame.endFill();
        crisisFrame.alpha = 0;

        globalContainer.addChild(storiesFrame);
        globalContainer.addChild(storiesContainer);

        globalContainer.addChild(scenesContainer);
        globalContainer.addChild(crisisFrame);
        globalContainer.addChild(guiContainer);

        stage.addChild(globalContainer);

        // window.pixiRenderer = renderer;

        this.setState({
            stage,
            scenesContainer,
            storiesContainer,
            storiesFrame,
            guiContainer,
            crisisFrame,
            renderer,
            rendererType,
            onReadyCalled: true,
            ...frameSize,
        }, () => {
            this.resize();
        });
    },

    onTick: function () {
        if (this.props.stage.playing) {
            if (this.state.renderer) {
                this.state.renderer.render(this.state.stage);
            }
            this.state.events.emit('tick');
            // timedDebug('yo');
        }
    },

    onMouseDown: function (e) {
        if (e.button === 2) {
            return;
        }

        this.state.events.emit('mousedown', {
            event: e,
        });

        this.setState({
            mouseDown: true,
        });
    },

    onMouseMove: function (e) {
        // if (!this.props.stage.playing) return;
        const state = this.state;
        const props = this.props;

        let deltaX = 0;
        if (props.stage.messageBoxPlaying === true) {
            deltaX = state.mouseClientX === null ? 0 : e.clientX - state.mouseClientX;
        }

        state.events.emit('mousemove', {
            event: e,
            mouseDown: state.mouseDown,
            deltaX,
            deltaY: state.mouseClientY === null ? 0 : e.clientY - state.mouseClientY,
        });
    },

    onMouseUp: function (e) {
        // if (!this.props.stage.playing) return;
        if (e.button === 2) {
            return;
        }

        this.state.events.emit('mouseup', {
            event: e,
        });

        this.setState({
            mouseDown: false,
        });
    },

    onWheel: function (e) {
        if (!this.props.stage.playing) return;
        // console.log('what');
        // e.preventDefault();
        this.state.events.emit('wheel', {
            event: e,
        });
    },

    onMessageWillShow: function(message)
    {
        // if (message.text === '%CRASH%') {
        //     TweenMax.to(this.state.crisisFrame, 2, {
        //         alpha: 1,
        //         ease: Quad.easeInOut,
        //     });
        // }
    },

    onSceneChange: function(sceneKey) {
        const context = this.context;
        const props = this.props;
        let key = null;

        if (sceneKey === 'intro' || sceneKey === 'menu' || sceneKey === 'credits' || !sceneKey) {
            // key = `/${this.props.language}`;
            key = '/';
        } else {
            // key = `/${this.props.language}/${sceneKey}`;
            key = `/${sceneKey}`;
        }

        if (mobile || isIE()) {
            // Forcing a reload is best in mobile situations to avoir out of memory errors
            window.location.href = key;
        } else {
            context.router.push(key);
            context.store.dispatch(new StageActions.setScene(sceneKey || 'intro'));
            context.store.dispatch(
                new StageActions.setFrameDone(props.sceneKey, 0),
            );

            sendPageView();
        }
    },

    onSceneMount: function() {
        // console.log('scene mount');
        // this.setScale();
        this.setState({
            ready: true,
        });
    },

    onSceneUnmount: function() {
        const { storiesContainer } = this.state;
        this.setState({
            ready: false,
        });
    },

    onToggleMenu: function() {
        this.context.store.dispatch(StageActions.setMenuOpen(!this.props.stage.menuOpen));
        this.context.store.dispatch(StageActions.setPlaying(!this.props.stage.playing));
    },

    onTogglePause: function () {
        const nextPlayingState = !this.props.stage.messageBoxPlaying;
        this.context.store.dispatch(
            StageActions.setMessageBoxPlaying(nextPlayingState),
        );
    },

    setPreviousVolume: function (previousVolume) {
        this.setState({
            previousVolume,
        });
    },

});

module.exports = App;



// WEBPACK FOOTER //
// ./js/components/App.jsx